import React, { useEffect, useState } from "react";
import pen from "../../assets/images/pen.svg";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import * as toast from "../../utils/makeToast";
import { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { trimImageURI } from "../../utils/imageUpload";
import { accountOpeningSteps } from "../../utils/constants";
import ChequeBookModal from "../ChequeBookModal";
import "youverify-web-sdk";
import Loader from "../Loader";
import {
  extractValuesFromObj,
  handleNumericInput,
  handleNumericPaste,
  returnInputErrorMessage,
} from "../../utils/helpers";
import apiHooks from "../../customHooks/apis";
import DocUpload from "../DocUpload";
import useUserValidated from "../../customHooks/useUserValidated";
import CustomInputField from "../CustomInputField/CustomInputField";
import ImageUploadAndLivePhoto from "../ImageUploadAndLivePhoto";
import { pushDocumentsUploaded } from "../../utils/dataLayerEvents";
import CameraComponent from "../CameraComponent";
import UploadSignatureCard from "../UploadSignatureCard";
import SignaturePad from "../SignaturePad";
import CustomModal from "../Modal/CustomModal";

interface IuploadPayload {
  id: number;
  uploadSignature: string;
  frontPageId: string;
  debitCardValueAddedService: boolean;
  accountTypecode: string;
  accountTypeName: string;
  utilityBill: string;
  identityCardType: number;
  idCardNumber: string;
  issueDate: string;
  expiryDate: string;
  uploadPicture: string;
}
function UploadDocumentCurrentDialog(props: any) {
  const dispatch = useDispatch();

  const formik = useFormik<IuploadPayload>({
    initialValues: {
      id: 0,
      uploadSignature: "",
      frontPageId: "",
      debitCardValueAddedService: true,
      accountTypecode: "",
      accountTypeName: "",
      utilityBill: "",
      identityCardType: 5,
      idCardNumber: "",
      issueDate: "",
      expiryDate: "",
      uploadPicture: localStorage.getItem("userImage") || "",
    },
    validationSchema: yup.object({
      id: yup.string().required(),
      frontPageId: yup.string().required("Front Page ID is required"),
      debitCardValueAddedService: yup.boolean().required(),
      identityCardType: yup
        .number()
        .integer()
        .min(0)
        .required("Identity Card Type is required"),
      idCardNumber: yup.string().required("ID card number is required"),
      uploadPicture: yup.string(),
    }),

    validateOnMount: true,
    onSubmit: (values) => {
      uploadDcouments(values);
    },
  });
  const { isValidated } = useUserValidated();
  const [updating, setUpdating] = useState(false);
  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [pictureImageUrl, setPictureImageUrl] = useState("");
  const [utilityBillImageUrl, setutilityBillImageUrl] = useState("");
  const { useUploadFile, useUserDetails } = apiHooks;
  const { uploadingFile, handleUploadFile } = useUploadFile();
  const [signatureImageBase64, setSignatureImageBase64] = useState("");
  const [pictureImageBase64, setPictureImageBase64] = useState("");
  const [utilityBillImageBase64, setUtilityBillImageBase64] = useState("");

  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingPictureImage, setSettingPictureImage] =
    useState<boolean>(false);
  const [settingutilityBillImage, setSettingUtilityBillImage] =
    useState<boolean>(false);
  const { userDetails } = useUserDetails();
  const [isUploading, setIsUploading] = useState(false);
  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [livePictureDocumentName, setLivePictureDocumentName] =
    useState<string>("");

  const [showSignaturePad, setShowSignaturePad] = useState<boolean>(false);
  const [signatureName, setSignatureName] = useState<"draw" | "upload" | "">(
    "",
  );
  const validationType = localStorage.getItem("validationType");

  //

  const goToStep = (step: any) => {
    if (step === "update-detail") {
      localStorage.setItem("previous-screen", "document-upload");
    }
    dispatch(setAccountOpeningStep(step));
  };
  let fileUploadObj: any;

  const uploadDcouments = (values: IuploadPayload) => {
    let uploadDocumentPayload = {
      ...values,
      id: userDetails?.uploadid,
      frontPageId: values?.frontPageId,
      accountTypecode: localStorage.getItem("altFinanceGlCode"),
      accountTypeName: localStorage.getItem("altFinanceAccountType"),
      identityCardType: values?.identityCardType,
      idCardNumber: values?.idCardNumber,
      issueDate: values?.issueDate,
      expiryDate: values?.expiryDate,
      debitCardValueAddedService: values?.debitCardValueAddedService,
      uploadPicture: values?.uploadPicture,
    };
    if (!uploadDocumentPayload.uploadSignature) {
      toast.errorToast("Please provide a signature");
      return;
    }
    if (!uploadDocumentPayload.utilityBill) {
      toast.errorToast("Please provide a Utility Bill");
      return;
    }
    setUpdating(true);
    axios
      .post(
        `${baseUrl}CurrentAccount/CurrentDocumentUpload`,
        uploadDocumentPayload,
      )
      .then((response) => {
        setUpdating(false);
        if (
          response?.data?.length > 0 &&
          response?.data[0]?.responseCode == "20"
        ) {
          toast.errorToast(response?.data[0]?.responseMessage);
          return;
        }
        if (response?.data[0]?.accountNo) {
          localStorage.setItem(
            "generatedAccountNumber",
            response.data[0].accountNo,
          );
          pushDocumentsUploaded("personal");
          dispatch(
            setAccountOpeningStep(accountOpeningSteps.accountOpeningSuccess),
          );
          return;
        }

        if (response?.data[0]?.responseCode !== "00") {
          toast.errorToast(response?.data?.[0]?.responseMessage);
          return;
        }

        if (!response?.data?.isSuccess || !response?.data[0]?.accountNo) {
          toast.errorToast(response?.data[0]?.responseMessage);
          return;
        }

        localStorage.setItem(
          "generatedAccountNumber",
          response.data[0].accountNo,
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        setUpdating(false);
        toast.errorToast("Something went wrong");
      });
  };

  const getExistingDetails = () => {
    formik.setValues({
      ...formik.initialValues,
      ...extractValuesFromObj(formik.initialValues, userDetails),
      idCardNumber: userDetails.nin || "",
    });
  };

  useEffect(() => {
    getExistingDetails();
  }, []);

  const uploadImage = (payload: any, type: string) => {
    if (type === "signature") {
      setSettingSignatureImage(true);
    }
    if (type === "frontPageId") {
    }

    if (type === "utilityBill") {
      setUtilityBillImageBase64(payload.postedFilebase64);
      setSettingUtilityBillImage(true);
    }
    if (type === "image") {
      setPictureImageBase64(payload.postedFilebase64);
      setSettingPictureImage(true);
    }
    if (type === "referralForm") {
    }
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        if (type == "signature") {
          setSignatureImageUrl(response.data?.id);
          setSettingSignatureImage(false);
        } else if (type == "frontPageId") {
        } else if (type == "image") {
          setPictureImageUrl(response.data?.id);
          setSettingPictureImage(false);
        } else if (type == "utilityBill") {
          setutilityBillImageUrl(response.data?.id);
          setSettingUtilityBillImage(false);
        } else if (type == "referralForm") {
        }
      })
      .catch((err) => {
        setSettingSignatureImage(false);
        setSettingPictureImage(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message,
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const handleTakePhoto = (dataUri: any) => {
    let res = trimImageURI(dataUri);
    setPictureImageUrl("data:image/jpg;base64," + res);
    setShowCamera(false);
    fileUploadObj = {
      postedFilebase64: dataUri,
      documentName: livePictureDocumentName,
      filetype: "png",
    };
    handleSubmit(livePictureDocumentName);
    setShowCamera(false);
  };

  const handleCameraError = (error: any) => {
    toast.errorToast("Something went wrong, please try again");
  };

  const handleCameraStart = () => {
    //
  };

  const handleCameraStop = () => {
    //
  };

  const toggleSignaturePad = (type: string, value: boolean) => {};

  const [loading, setLoading] = useState(false);

  function checkIsvalidated() {
    if (validationType === "bvn") {
      return false;
    } else {
      return !isValidated;
    }
  }

  const handleClickSave = (
    postedFilebase64: string,
    documentName: string,
    filetype: string,
    objectUrl: string,
  ) => {
    handleUploadFile(
      {
        postedFilebase64,
        documentName,
        filetype,
      },
      (url) => {
        setSignatureImageBase64(objectUrl);
        formik.setFieldValue("uploadSignature", url);
        setSignatureName("draw");
      },
    );
    setShowSignaturePad(false);
  };

  return (
    <div>
      {loading && <Loader />}

      {showCamera && (
        <div style={{ overflowX: "scroll" }} className="pt-2">
          <CameraComponent
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 640, height: 480 }}
            imageType={IMAGE_TYPES.PNG}
            imageCompression={0.97}
            isMaxResolution={false}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStop={() => {
              handleCameraStop();
            }}
            onCameraStart={() => {
              handleCameraStart();
            }}
          />
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              <a href="">Document upload</a>
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>

            <div
              className="row mr-3 align-items-end"
              style={{ display: "none" }}
            >
              {!signatureImageUrl ? (
                <React.Fragment>
                  <div
                    className={`${
                      validationType === "bvn" ? "col-12" : "col-sm-6"
                    } row`}
                  >
                    <div className="col-sm-6">
                      <div className="col-md-3 mt-4">
                        <div
                          className={`pic_upload ${
                            validationType === "bvn" ? "file_doc" : ""
                          } d-flex justify-content-between pt-3 pr-3 px-2`}
                          onClick={() => toggleSignaturePad("signature", true)}
                        >
                          <p className="label_text">
                            Draw an <br /> e-signature
                          </p>
                          <img className="img-fluid" src={pen} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {/* ---------------------- */}
            </div>
            <div className="row align-items-end">
              {(!signatureName || signatureName === "upload") && (
                <div
                  className={
                    signatureName === "upload" ? "col-lg-6" : "col-lg-3"
                  }
                >
                  <DocUpload
                    name="uploadSignature"
                    label="Draw/Upload Signature"
                    required
                    show
                    getFileUrl={(name, url) => {
                      formik.setFieldValue(name, url);
                      setSignatureName(url ? "upload" : "");
                    }}
                    setIsUploading={setIsUploading}
                    disabled={uploadingFile}
                  />
                </div>
              )}
              {(!signatureName || signatureName === "draw") && (
                <div
                  className={signatureName === "draw" ? "col-lg-6" : "col-lg-3"}
                >
                  <UploadSignatureCard
                    uploading={uploadingFile}
                    imageUrl={signatureImageBase64}
                    show
                    onClickCard={() => setShowSignaturePad(true)}
                    handleRemoveFile={(url) => {
                      formik.setFieldValue("uploadSignature", url);
                      setSignatureName("");
                      setSignatureImageBase64("");
                    }}
                    disabled={isUploading}
                  />
                </div>
              )}

              <div className="col-lg-6">
                <ImageUploadAndLivePhoto
                  getFileUrl={(url) =>
                    formik.setFieldValue("uploadPicture", url)
                  }
                />
              </div>
            </div>
            {/* ----------------------- */}

            <div className="w-100 mt-2">
              <DocUpload
                label="Upload utility bill (not older than 3 months)"
                required
                show
                errorMessage={returnInputErrorMessage<IuploadPayload>(
                  formik,
                  "utilityBill",
                )}
                name="utilityBill"
                getFileUrl={formik.setFieldValue}
              />
            </div>

            <div className="row">
              <label
                htmlFor="residentialaddress"
                className="label_text my-2 mt-4 font-weight-bold"
                style={{ display: "block", textAlign: "center" }}
              >
                <b>Means of Identification Document</b>
              </label>
            </div>

            <div className="d-flex flex-column flex-lg-row align-items-end w-100 gap-3">
              <CustomInputField
                label="Identity Card Type"
                value="National Identity Card"
                required
                disabled
              />
              <CustomInputField
                required
                label="National Identity Number (NIN)"
                placeholder="Enter ID Number"
                name="idCardNumber"
                value={formik.values.idCardNumber}
                onChange={formik.handleChange}
                onKeyDown={(e) =>
                  handleNumericInput(e, formik.values.identityCardType)
                }
                onPaste={(e) =>
                  handleNumericPaste(e, formik.values.identityCardType)
                }
                onBlur={formik.handleBlur}
                errorMessage={
                  returnInputErrorMessage<typeof formik.initialValues>(
                    formik,
                    "idCardNumber",
                  ) as string
                }
                disabled
              />
            </div>

            <div>
              <DocUpload
                name="frontPageId"
                required
                show
                label="Front page of ID"
                getFileUrl={formik.setFieldValue}
                bottomText="The file format should be JPEG, PNG or PDF  (max size: 2mb)"
              />
            </div>

            <div className="row container mt-3 ml-1">
              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox3"
                >
                  Would you like to have a Debit Card (Verve)
                </label>
              </div>

              {/* {!formik.values.debitCardValueAddedService && ( */}
              <div className="row container mt-3" id="dvPassport">
                <div className="col-md-3 form-group">
                  <div className="custom-control custom-radio input-group mb-2">
                    <input
                      name="debitCardValueAddedService"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "debitCardValueAddedService",
                          e.target.value === "true",
                        )
                      }
                      value="true"
                      type="radio"
                      className="custom-control-input debit-card-radio-input"
                      id="rad1"
                      checked={
                        formik.values.debitCardValueAddedService === true
                      }
                    />
                    <label className="custom-control-label pl-3" htmlFor="rad1">
                      Yes
                    </label>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <div className="custom-control custom-radio input-group mb-2">
                    <input
                      name="debitCardValueAddedService"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "debitCardValueAddedService",
                          e.target.value === "true",
                        )
                      }
                      value="false"
                      type="radio"
                      className="custom-control-input debit-card-radio-input"
                      id="rad2"
                      checked={
                        formik.values.debitCardValueAddedService === false
                      }
                    />
                    <label className="custom-control-label pl-3" htmlFor="rad2">
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep(accountOpeningSteps.addReference);
                }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                disabled={!formik?.isValid || checkIsvalidated()}
                type="submit"
                className="btn btn-filled-red"
              >
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>

      {/*  */}
      <button
        id="chequeBookModalButton"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#chequeBookModal"
      >
        test
      </button>
      <div
        className="modal fade"
        id="chequeBookModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content chequebook-modal-content">
            <div className="modal-body">
              <ChequeBookModal />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <CustomModal
        show={showSignaturePad}
        onClickClose={() => setShowSignaturePad(false)}
      >
        <SignaturePad onClickSave={handleClickSave} />
      </CustomModal>
    </div>
  );
}

export default UploadDocumentCurrentDialog;
